import { Cache } from "memory-cache";
import { CharacterContractEntity } from ".";
import { Client } from "../service/esiclient";
import { fetchCharacterTokenFromID } from "../helpers/tokenhelper";

const esiClient = new Client();
// Cache
const cache = new Cache();
export async function getCachedCharacterContractEntity(
  transaction_id: number
): Promise<CharacterContractEntity | null> {
  let entity: any = await cache.get(transaction_id.toString());
  if (entity) {
    return entity;
  }
  return null;
}
export function setCachedCharacterContractEntity(id: CharacterContractEntity) {
  cache.put(id.props.contract_id.toString(), id, 60 * 60 * 1000 /* 1 hour */);
}

export async function getCachedContractItems(contract_id: number, character_id: number): Promise<any | null> {
  let entity: any = await cache.get("items-" + contract_id.toString());
  if (entity) {
    return entity;
  }
  try {
    const accesstoken = await fetchCharacterTokenFromID(character_id);
    if (accesstoken.success) {
      setTimeout(() => {}, 1000);
      const contract_items = await esiClient.get_characters_character_id_contracts_contract_id_items(
        character_id,
        contract_id,
        null,
        null,
        accesstoken.token
      );
      if (contract_items !== null) {
        entity = contract_items;
        cache.put("items-" + contract_id.toString(), entity, 60 * 60 * 1000 /* 1 hour */);
        return entity;
      } else {
        return null;
      }
    } else {
      return null;
    }
  } catch (error) {
    return null;
  }
}

export async function getCachedContractBids(contract_id: number, character_id: number): Promise<any | null> {
  let entity: any = await cache.get("bids-" + contract_id.toString());
  if (entity) {
    return entity;
  }
  try {
    const accesstoken = await fetchCharacterTokenFromID(character_id);
    if (accesstoken.success) {
      setTimeout(() => {}, 1000);
      const bids = await esiClient.get_characters_character_id_contracts_contract_id_bids(
        character_id,
        contract_id,
        null,
        null,
        accesstoken.token
      );
      if (bids !== null) {
        entity = bids;
        cache.put("bids-" + contract_id.toString(), entity, 60 * 60 * 1000 /* 1 hour */);
        return entity;
      } else {
        return null;
      }
    } else {
      return null;
    }
  } catch (error) {
    return null;
  }
}
